export const createExemptionFormData = {
    civility: '',
    firstName: '',
    lastName: '',
    birthName: '',
    phoneNumber: '',
    employeeNumber: '',
    externalId: '',
    email: '',
    contractTypeId: '',
    birthDate: '',
    deadlineDate: '',
    dueDate: '',
    guarantyEffectiveDate: '',
    employmentDate: '',
    beneficiaryId: null,
    dueId: null,
    oppositeDueId: null,
    startDate: '',
    exemptionReason: {
        reasonId: 0,
        documents: [],
        expirationDate: ''
    }
};